export default "__VITE_ASSET__e010ce1e__"